export const ConfirmStatusTemplate = [
  {
    value: 'CONFIRMED',
    description: '確認済み'
  },
  {
    value: 'UNCONFIRM',
    description: '未確認'
  }
];